var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useCallback, memo } from 'react';
import styled from 'styled-components';
var OffsetLayer = function (_a) {
    var target = _a.target, children = _a.children, _b = _a.move, move = _b === void 0 ? { top: 0, left: 0 } : _b, _c = _a.zIndex, zIndex = _c === void 0 ? 5 : _c, closedLayer = _a.closedLayer;
    var _d = useState(false), complete = _d[0], setComplete = _d[1];
    var _e = useState({ top: 0, left: 0 }), targetDireact = _e[0], setTargetDireact = _e[1];
    var _f = useState(0), bodyHeight = _f[0], setBodyHeight = _f[1];
    var setTargetOffest = useCallback(function (t) {
        var rect = t.getBoundingClientRect();
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var offset = {
            top: rect.top + scrollTop + move.top,
            left: rect.left + scrollLeft + move.left,
        };
        setTargetDireact(offset);
    }, []);
    var stopPropagation = useCallback(function (e) {
        e.stopPropagation();
    }, []);
    var resize = useCallback(function () {
        setTargetOffest(target);
        setBodyHeight(document.body.offsetHeight);
    }, []);
    useEffect(function () {
        setComplete(true);
        resize();
        window.addEventListener('resize', resize);
        return function () { return window.removeEventListener('resize', resize); };
    }, []);
    useEffect(function () {
        setComplete(true);
    }, []);
    return (React.createElement(React.Fragment, null, complete && (React.createElement(Style, { bodyHeight: bodyHeight, zIndex: zIndex, onClick: closedLayer },
        React.createElement(Inner, { targetDireact: targetDireact, onClick: stopPropagation }, children)))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: ", "px;\n    z-index: ", ";\n"], ["\n    position: absolute;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: ", "px;\n    z-index: ", ";\n"])), function (_a) {
    var bodyHeight = _a.bodyHeight;
    return bodyHeight;
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
});
var Inner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: ", "px;\n    left: ", "px;\n"], ["\n    position: absolute;\n    top: ", "px;\n    left: ", "px;\n"])), function (_a) {
    var targetDireact = _a.targetDireact;
    return targetDireact.top;
}, function (_a) {
    var targetDireact = _a.targetDireact;
    return targetDireact.left;
});
export default memo(OffsetLayer);
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/offset_layer.tsx
// module id = 98
// module chunks = 0